{
    "status": {
        "due": "Due",
        "overdue": "Overdue",
        "completed": "Completed"
    },
    "blankAnswer": "Left blank",
    "list": {
        "title": "Diaries",
        "emptyTitle": "No Diaries Yet",
        "emptyDescription": "Diaries created for you appear here",
        "checkAgain": "Check Again",
        "needsAttention": "Needs your attention",
        "needsAttentionDesc": "Diaries with forms waiting for your next entry.",
        "upToDate": "Up to date",
        "ongoing": "Ongoing",
        "ongoingDesc": "Diaries that are in progress or waiting for your first entry.",
        "upToDateDesc": "Diaries in progress with no entries due right now.",
        "noOngoing": "No ongoing diaries at the moment",
        "completed": "Completed",
        "completedDesc": "Diaries that have finished (no longer collecting entries).",
        "noCompleted": "No completed diaries yet",
        "openDiary": "Open diary",
        "reviewDiary": "Review diary"
    },
    "goToDiaries": {
        "title": "Go to {{diaryWord}}",
        "actionRequiredCount": "Action Required ({{count}})",
        "actionRequiredOneForm": "Action Required ({{count}} form)",
        "actionRequiredManyForms": "Action Required ({{count}} forms)",
        "defaultDescription": "Diaries serve as your personal health logs, helping improve treatment and research.",
        "oneFormDue": "You have {{count}} form that needs to be completed.",
        "manyFormsDue": "You have {{count}} forms that need to be completed.",
        "diariesNeedAttention": "You have {{count}} {{diaryWord}} with forms that need your attention."
    }
}
